import EventEmitter from 'eventemitter3';

export interface AppEvent {
  'user:logout': void;
  /**
   * The local user acted on the live camera. Emitted from the interaction handlers themselves,
   * NOT from the socket's inbound propagation — `propagateZoom` / `propagateClick` also fire for
   * other viewers in the habitat, and a tour step must only advance on what *this* user did.
   */
  'habitat:camera-zoomed': { habitatId: string; cameraId: string };
  'habitat:camera-panned': { habitatId: string; cameraId: string };
  'habitat:camera-switched': { habitatId: string; cameraId: string };
  /**
   * The local user took a clip or a snapshot — the capture arrived and its save modal opened. This
   * is *not* success on its own: the onboarding uses it only to move from "take a clip" to
   * "now save it". Success is `habitat:media-saved`.
   */
  'habitat:media-captured': { habitatId: string; kind: 'clip' | 'snapshot' };
  /** The local user actually saved the clip/snapshot to their album — the onboarding's success signal. */
  'habitat:media-saved': { habitatId: string; kind: 'clip' | 'snapshot' };
  /** The local user dismissed the capture without saving — the onboarding sends them back to try again. */
  'habitat:media-discarded': { habitatId: string; kind: 'clip' | 'snapshot' };
  /** The local user switched habitat tabs (Meet / Watch / Learn / Chat). */
  'habitat:tab-changed': { tab: string };
  /** The local user followed the habitat. Only the follow direction is emitted, not unfollow. */
  'habitat:followed': { habitatId: string };
}

const appEvents = new EventEmitter<AppEvent>();

export default appEvents;
